import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import FeedBackService from '../Services/FeedBackService';
import '../Feedback/FeedBack.css';
import SweetAlertService from '../../../services/SweetAlertService';
import { Link } from 'react-router-dom';

export const Help = () => {
    const [comments, setComments] = useState('');
    const [isConsentToContact, setIsCheckboxChecked] = useState(true);
    const [isConfirmed, setIsConfirmed] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const onSubmit = (data: any) => {
        FeedBackService.sendSupportRequest(data)
            .then((res: any) => {
                if (res) {
                    setIsConfirmed(true);
                    setComments('');
                    setIsCheckboxChecked(true);
                } else {
                    SweetAlertService.error("Error", "Something went wrong while submitting the request");
                }
                reset();
            })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while submitting the request");
            });
    };

    const handleChangeComments = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setComments(event.target.value);
        //if (event.target.value.length <= 0) {
        //    setIsCheckboxChecked(false);
        //}
    };

    const handleCheckboxChange = (event: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        setIsCheckboxChecked(event.target.checked);
    };

    return (
        <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <fieldset className="container">
                        <div>
                            &nbsp;
                            <h2>Get support</h2>
                            <p className="my-2">
                                <a href="https://www.bma.org.uk/gpdiary" target="_blank" rel="noopener noreferrer">
                                    <span className="faq-link"><u>Find out more about GP Diary on the BMA website </u></span></a>and <Link to="/faqs" className="customLink"><u>find answers to common questions about GP Diary</u></Link>.
                            </p>
                            <h2 className="mt-3">Get in touch</h2>
                            <p className="mt-3 mb-0">If you’re experiencing issues using GP Diary and the answers in our FAQs section haven’t resolved your problem, we’re here to help.</p>
                            <p className="mt-1 mb-0">Please complete the form below with as much information as possible. This will help us capture all the details we need to resolve your issue quickly.</p>
                            <p className="mt-3 mb-0">Please include the device type you are using (mobile or desktop) and the browser you are using. If you're using a mobile device please do also tell us the make and ideally also the model.</p>
                            <p className="mt-3 mb-0">You will then be contacted using the email address you have registered with.</p>
                        </div>
                        {comments && (
                            <div className="form-group">
                                <div className="mt-4 mb-4">
                                    <span className="text">
                                        <input className="checkbox"
                                            type="checkbox"
                                            {...register('isConsentToContact')}
                                            id="isConsentCheckbox"
                                            checked={isConsentToContact}
                                            //onChange={handleCheckboxChange}
                                            onClick={(e) => e.preventDefault()}
                                            readOnly
                                        />{' '}
                                        I would like to be contacted in response
                                    </span>
                                </div>
                            </div>
                        )}
                        <div className="mt-3 form-group">
                            <textarea
                                className="form-control"
                                rows={8}
                                {...register('comments')}
                                onChange={handleChangeComments}
                                placeholder="Post your feedback here..."
                            ></textarea>
                            {comments.length > 1000 && (
                                <span className="text-danger">
                                    Maximum 1000 characters
                                </span>
                            )}
                        </div>
                        <div>
                            {comments && (
                                <button
                                    type='submit'
                                    className="btn btn-primary mt-2"
                                >
                                    Send
                                </button>
                            )}
                            &nbsp;
                            {(isConfirmed && !comments) && (<span>
                                <img className="checkmark" src={require('../../../assets/images/checkmark.png')} alt="checkbox" />Thank you for your message
                            </span>
                            )}
                        </div>
                    </fieldset>
                </div>
            </form>
        </div>
    );
};